import { render, staticRenderFns } from "./MortgageLoans.vue?vue&type=template&id=087a3f17&scoped=true"
import script from "./MortgageLoans.vue?vue&type=script&lang=js"
export * from "./MortgageLoans.vue?vue&type=script&lang=js"
import style0 from "./MortgageLoans.vue?vue&type=style&index=0&id=087a3f17&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a3f17",
  null
  
)

export default component.exports